import React from "react";

const Menu = () => {
    return (
        <React.Fragment>
            <div className="menuBackground">
                <center>
                    {/* ************************start ************** */}
                    <h1 className="menuCati">Appetizers</h1>
                    <div className="menuFlex-container">
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Chips</li>
                                <li className="menuDescripton">With your choice of salsa & guacamole or Cheese & beans.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Super Nachos</li>
                                <li className="menuDescripton">Crunchy nachhos with beans, Cheese, tomato, sour cream,and guacamole, topped with your choice of steak, pork or Chicken.
                                </li>

                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Guacamole</li>

                            </ul>
                        </div>
                    </div>
                    {/* ****************end********** */}
                    {/* ************************start ************** */}
                    <h1 className="menuCati">Tortas</h1>
                    <div className="menuFlex-container">
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Ribeye(Lomo de Res)</li>
                                <li className="menuDescripton">Bolillo Bread filled with grilled ribeye steak, fresh lettuce, tomato, onion,
                                    avocado & mayo.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Ham & Cheese</li>
                                <li className="menuDescripton">Bolillo Bread filled with Ham, Jack Cheese, fresh lettuce, tomato, onion, avocado, & mayo.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Pork(Puereo)</li>
                                <li className="menuDescripton">Bolillo Bread filled with chunk of grill pork, fresh lettuce, tomato, onion, avocado & mayo.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Machaca</li>
                                <li className="menuDescripton">Bolillo Bread filled with shredded beef sauteed onions, tomato, bell peppers, beans mayo & egg [ or w/o]
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Pollo /Chicken</li>
                                <li className="menuDescripton">Bolillo Bread filled with shredded seasoned Chicken breast, fresh lettuce, tomato, onion,
                                bell peppers, avocado & mayo.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Milanesa</li>
                                <li className="menuDescripton">Bolillo Bread filled with breaded ribeye steak, fresh lettuce, tomato. onion, avocado, & mayo.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Huevo Con Jamon(Ham & eggs)</li>
                                <li className="menuDescripton">Bolillo Bread filled with eggs & ham fresh lettuce, tomato, onion, bell peppers, avocado, & mayo.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Huevo Con Chorizo</li>
                                <li className="menuDescripton">Bolillo Bread filled with eggs & Mexican sausage mayo and beans.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Tuna</li>
                                <li className="menuDescripton">Bolillo Bread filled with chunks of light tuna, onion, celery, lettuce, tomato & mayo.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Veggie</li>
                                <li className="menuDescripton">Bolillo Bread filled with Jack Cheese, fresh lettuce, onion, tomato, mayo & beans.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Al Pastor</li>
                                <li className="menuDescripton">Bolillo Bread filled with chunk of grilled pork, fresh lettuce, onions , tomato & mayo.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Torta Cubana</li>
                                <li className="menuDescripton">Bolillo Bread filled with ribeye pork milanesa, ham, Cheese, fresh lettuce, onions, tomato & mayo
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* ****************end********** */}
                    {/* ************************start ************** */}
                    <h1 className="menuCati">Burritos</h1>
                    <div className="menuFlex-container">
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Carne asada</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Al Pastor</li>

                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Pollo /Chicken</li>

                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Machaca</li>

                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Puerco</li>

                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Huevo Con Chorizo</li>

                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Huevo Con Jamon(Ham & eggs)</li>

                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Frijol y Queso</li>

                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Burrito Mojado</li>

                            </ul>
                        </div>
                    </div>
                    {/* ****************end********** */}
                    {/* ************************start ************** */}
                    <h1 className="menuCati">Pupusas</h1>
                    <div className="menuFlex-container">
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Bean & Cheese</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Revueltas</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Queso</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Chicharron</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Queso y Loroco</li>
                            </ul>
                        </div>
                    </div>
                    {/* ****************end********** */}
                    {/* ************************start ************** */}
                    <h1 className="menuCati">Salads</h1>
                    <div className="menuFlex-container">
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Tuna salad</li>

                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Chicken Salad</li>

                            </ul>
                        </div>
                    </div>
                    {/* ****************end********** */}
                    {/* ************************start ************** */}
                    <h1 className="menuCati">Drinks</h1>
                    <div className="menuFlex-container">
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Squirt</li>

                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">7up</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Coca-cola</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Jarritos</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">A&W Root Beer</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Sidral Mundet</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Sangria</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Sunkist</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Horchata</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Jamaica</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Tamarindo</li>
                            </ul>
                        </div>
                    </div>
                    {/* ****************end********** */}
                    {/* ************************start ************** */}
                    <h1 className="menuCati">Beers</h1>
                    <div className="menuFlex-container">
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Miller lite</li>

                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Bud Light</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Budwiser</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Michelada</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Tecate</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Corona</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Negra Modelo</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Bohemia</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Heineken</li>
                            </ul>
                        </div>
                        <div>
                            <ul className="menuItems">
                                <li className="itemName">Suprema</li>
                            </ul>
                        </div>

                    </div>
                    {/* ****************end********** */}
                </center>
            </div>

        </React.Fragment>
    )
}

export default Menu;